import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Observable, forkJoin } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { ApiResponse } from '../../shared/common-model/common.model';
import { soAddDTO, soClientProvideLaborInfoBaseAddDTO, soUpdateGeneralInfoAddUpdateDTO, soViewModel, soViewModelForDetails } from '../models/service-order.model';
import { SpinnerService } from '../../shared/services/spinner.service';
import { CommonToastService } from '../../shared/services/common-toast.service';
import { ClientService } from '../../admin/services/client-management/client.service';
import { soPrepareInboundFreightViewModel } from '../models/service-order-prepare-inbound.model';
import { soPrepareOutboundFreightViewModel } from '../models/service-order-prepare-outbound.model';
import { clientManageInstructionForSO, soPrepareSpecialInstCatDisplayUpdateForSOViewDTO, soPrepareSpecialInstNoteUpdateForSOViewDTO, soPrepareSpecialInstructionViewModel } from '../models/service-order-prepare.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderPrepareService {
  constructor(private httpRequestService: HttpRequestService, private spinnerService:SpinnerService, 
    private commonToastService:CommonToastService, private clientService:ClientService) { }
  
  updateSOPrepareInboundFreight(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdatePrepareInboudFreight, data);
  }
  getSoPrepareInboundFreight(soId: any): Observable<soPrepareInboundFreightViewModel> {
    return this.httpRequestService.getData<soPrepareInboundFreightViewModel>(`${ApiUrlConstants.soGetPrepareInboudFreight}${soId}`);
  }
  billDownload(fileDocId: string): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.soPrepareInboundBillFileDownload}${fileDocId}`);
  }
  updateSOPrepareOutboundFreight(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soUpdatePrepareOutboundFreight, data);
  }
  getSoPrepareOutboundFreight(soId: any): Observable<soPrepareOutboundFreightViewModel> {
    return this.httpRequestService.getData<soPrepareOutboundFreightViewModel>(`${ApiUrlConstants.soGetPrepareOutboundFreight}${soId}`);
  }
  outBoundbillDownload(fileDocId: string): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.soPrepareOutboundBillFileDownload}${fileDocId}`);
  }
  deletePrepareOutboundShipmentById(shipmentId: string): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soPrepareOutboundShipmenetDelete}${shipmentId}`);
  }

  addUpdateSOPrepareSpecialInstruction(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soPrepareSpInstructionAddUpdate, data);
  }
 
  getAllSOPrepareSpInstructions(soId: any): Observable<soPrepareSpecialInstructionViewModel[]> {
    return this.httpRequestService.getData<soPrepareSpecialInstructionViewModel[]>(`${ApiUrlConstants.soPrepareSpInstructionGetAll}${soId}`);
  }
  deleteSOPrepareSpecialInstructionById(id: string): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soPrepareSpInstructionDelete}${id}`);
  }
  getSOPrepareClientManageInstructions(data: any): Observable<clientManageInstructionForSO[]> {
    return this.httpRequestService.postData<clientManageInstructionForSO[]>(ApiUrlConstants.soPrepareClientManageSpInstructionGetList, data);
  }
  getAllSpecialInstructions(data: any, soId: string): Observable<any[]> {
    const getAllClientInstructions = this.httpRequestService.postData<clientManageInstructionForSO[]>(ApiUrlConstants.soPrepareClientManageSpInstructionGetList, data);
    const getAllSoInstructions = this.httpRequestService.getData<soPrepareSpecialInstructionViewModel[]>(`${ApiUrlConstants.soPrepareSpInstructionGetAll}${soId}`);
    return forkJoin([getAllClientInstructions, getAllSoInstructions ]);
  }

  soViewUpdateSpecialInstNote(data: soPrepareSpecialInstNoteUpdateForSOViewDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soViewUpdateSpecialInstNote, data);
  }
  soViewUpdateSpecialInstCatDisplay(data: soPrepareSpecialInstCatDisplayUpdateForSOViewDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soViewUpdateSpecialInstCatDisplay, data);
  }
}
